/**
 * input 2024-02-06T00:00:00
 * output 2024.02.06 00:00
 */
export const transformDateTime = (inputDate) => {
  const [datePart, timePart] = inputDate.split("T");
  const [year, month, day] = datePart.split("-");
  const [hour, minute] = timePart.split(":");

  const transformedDate = `${year}.${month}.${day} ${hour}:${minute}`;

  return transformedDate;
};
